import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_DETAILS } from './url-constants';

type SiteDetailsEndpointSpecification = ApiEndpointSpecification;
export const SiteDetailsEndpointSpecification: SiteDetailsEndpointSpecification = {
    url: SITE_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteDetailsRequestParams',
    requestBodySchemaName: 'SiteDetailsRequestBody',
    okResponseSchemaName: 'SiteDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteDetails = Helpers.makeApiRequestFn<
    Types.SiteDetailsRequestParams,
    Types.SiteDetailsRequestBody,
    Types.SiteDetailsOkResponse
>(SiteDetailsEndpointSpecification);
